export class HttpConstants {
    static ACCESSTOKEN_COOKIE_NAME: string = "sosmartContext";
    static HEADER_AUTHORIZATION: string = "Authorization";
    static BEARER_AUTH: string = "Bearer";
    static HEADER_XAPIKEY: string = "X-API-KEY";
}